import ChipInput from 'material-ui-chip-input';
import React, { Component } from 'react';
import emailValidator from '../shared/emailValidator';


const styles = {
    chipLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '.8rem',
        marginBottom: 0
    }
};

export default class EmailChipInput extends Component {

    handleChangeUpdate(emails) {
        let event = {
            target : {
                id : "emails",
                value: emails || []
            }
        }
        this.props.onChange(event);
    }

    render() {
        return (
            <div style={{ width: '550px', marginTop: '10px' }}>
                <label style={styles.chipLabel}>Emails</label>
                <ChipInput
                    id="emails"
                    fullWidth={true}
                    value={this.props.emails || []}
                    classes={{
                        chipContainer: 'chip-container',
                    }}
                    blurBehavior='add'
                    onBeforeAdd={(chip) => {
                        return emailValidator.isValid(chip)
                    }}
                    onAdd={(chip) => {
                        const emails = this.props.emails || []
                        this.handleChangeUpdate([...emails, chip]);
                    }}
                    onDelete={(chip) => this.handleChangeUpdate(this.props.emails && this.props.emails.filter(email => email !== chip))}
                />
            </div>  
        );
    }


}